/* eslint-disable no-undef */
(function (root, factory) {
    if (typeof module === 'object' && module.exports) {
        module.exports = factory(
            require('backbone'),
            require('lodash'),
            require('jquery'),
            require('cookies-js'),
        );
    } else if (typeof define === 'function' && define.amd) {
        define(['backbone', 'lodash', 'jquery'], function (Backbone, _, $) {
            return factory(Backbone, _, $, {
                expire: $.removeCookie,
                set: $.cookie,
            });
        });
    }
})(this, function (Backbone, _, $, Cookies) {
    'use strict';

    var COOKIE = 'ebfp_i';

    return Backbone.Model.extend({
        config: {
            url: '/ajax/fp.png',
        },

        /**
         * Retrieves the value from the image cache.
         *
         * This is done by drawing the image to an invisible canvas and then reading
         * the RGB data as text.
         */
        getValue: function () {
            var canvas = document.createElement('canvas'),
                ctx = canvas.getContext('2d'),
                image = new Image(),
                $deferred = new $.Deferred();

            function onloadHandler() {
                var output, imData;

                ctx.drawImage(image, 0, 0);
                imData = ctx.getImageData(0, 0, 32, 1).data;
                output = _.map(imData, function (x, i) {
                    // Ignore the alpha channel, and trailing \0 bytes.
                    if (i % 4 === 3 || x === 0) {
                        return '';
                    }
                    return String.fromCharCode(x);
                }).join('');
                $deferred.resolve(output);
            }

            // Signal read mode.
            Cookies.expire(COOKIE);
            image.onload = onloadHandler;
            image.onerror = function () {
                try {
                    // Then the image is cached and the server responds with a
                    // 304 Not Modified, the image data is still valid, so
                    // continue processing.
                    onloadHandler();
                } catch (e) {
                    $deferred.resolve('');
                }
            };

            image.src = this.config.url;

            return $deferred.promise();
        },
        /**
         * Write the value to the image cache.
         *
         * This is simple done by setting the value to the COOKIE and requesting
         * the image.
         */
        setValue: function (value) {
            var image = new Image(),
                $deferred = new $.Deferred();

            // Signal write mode.
            Cookies.set(COOKIE, value, { path: '/' });

            image.onload = function () {
                Cookies.expire(COOKIE);
                $deferred.resolve(true);
            };

            image.onerror = function () {
                // We can never really tell if it succeeded anyway.
                $deferred.resolve(true);
            };

            image.src = this.config.url;

            return $deferred.promise();
        },
    });
});
